import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'
import Blanket from '~/_shared/models/Blanket'

export const state = {
  blankets: [],
  total: 0,
  blanket: new Blanket(),
  pdf: undefined,
  hasBlanketItems: true,
  list: []
}

export const getters = {
  list: state => state.list,
  blankets: state => state.blankets,
  total: state => state.total,
  blanket: state => state.blanket,
  pdf: state => state.pdf,
  hasBlanketItems: state => state.hasBlanketItems
}

export const mutations = {
  BLANKETS (state, data) {
    state.blankets = data
  },
  LIST (state, data) {
    state.list = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  BLANKET (state, data) {
    state.blanket = data
  },

  PDF (state, data) {
    state.pdf = data
  },

  HAS_BLANKET_ITEMS (state, data) {
    state.hasBlanketItems = data
  }
}

export const actions = {
  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(
      laroute.route('blankets_filter', { companyAbbr: store.getters['auth/company'], ...filterData })
    )

    data.items.map((blanket) => {
      blanket.created_at = moment(blanket.created_at).format('YYYY-MM-DD')
      blanket.due_date = moment(blanket.due_date).format('YYYY-MM-DD')
    })

    commit('BLANKETS', data.items)
    commit('TOTAL', data.total)
  },

  async getCustomerBlankets ({ commit }, { customerId }) {
    await axios.get(laroute.route('get-customer-blankets',
      { companyAbbr: store.getters['auth/company'], customerId })).then(res => {
      res.data.map((blanket) => {
        blanket.created_at = moment(blanket.created_at).format('YYYY-MM-DD')
        blanket.due_date = moment(blanket.due_date).format('YYYY-MM-DD')
      })
      commit('BLANKETS', res.data)
    })
  },

  async createBlanket ({ commit }, { formData }) {
    await axios.post(laroute.route('create-blanket', { companyAbbr: store.getters['auth/company'] }), { formData })
      .then((res) => {
        commit('BLANKET', Object.assign(new Blanket(), res.data.data))
      })
  },

  async deleteBlanket ({ commit }, { id, reason }) {
    await axios.patch(laroute.route('delete-blanket', { id }), { reason })
  },

  async getOne ({ commit }, id) {
    await axios.get(laroute.route('get-blanket', { companyAbbr: store.getters['auth/company'], id }))
      .then((res) => {
        res.data.due_date = moment(res.data.due_date).format('YYYY-MM-DD')
        res.data.created_at = moment(res.data.created_at).format('YYYY-MM-DD')
        res.data.blanket_items.forEach(function (item) {
          item.balance = item.balance == null ? 0 : item.balance
        })

        commit('BLANKET', Object.assign(new Blanket(), res.data))
      })
  },

  async deleteItem ({ commit }, id) {
    await axios.delete(laroute.route('delete-blanket-item', { id }))
  },

  async createItems ({ commit }, { id, items }) {
    await axios.post(laroute.route('create-blanket-items',
      { companyAbbr: store.getters['auth/company'] }),
    { id, items })
  },

  async update ({ commit }, { id, blanket, items }) {
    await axios.patch(laroute.route('update-blanket',
      { id }),
    { blanket, items })
  },

  async generatePDF ({ commit }, id) {
    const { data } = await axios.get(laroute.route('blanket-generate-pdf',
      { companyAbbr: store.getters['auth/company'], id }), { responseType: 'arraybuffer' })

    commit('PDF', data)
  },

  async getHasRelatedBlanketItems ({ commit }, { partnerId, items }) {
    const { data } = await axios.patch(laroute.route('get-has-blanket-items',
      { companyAbbr: store.getters['auth/company'] }), { partnerId, items })

    commit('HAS_BLANKET_ITEMS', data)
  },

  async getBlanketList ({ commit }, { searchValue }) {
    const { data } = await axios.get(laroute.route('blankets_filter',
      { companyAbbr: store.getters['auth/company'], blanketNo: searchValue }))

    commit('LIST', data.items)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/blanket.js